import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { TRIGGERS, EMOTIONS } from "@/mock";
import { useApp } from "@/context/AppContext";
import { IntensityField, SelectField, OutcomeField, STRATEGIES } from "@/components/craving/CravingFields";
import { toast } from "sonner";

export { intensityColor } from "@/components/craving/CravingFields";

const FEEDBACK = {
  resisted: ["Bravo ! Une victoire de plus.", "Ton cerveau apprend à résister."],
  gave_in: ["Noté. Sois bienveillant·e avec toi-même.", "Un écart est une information, pas un échec."],
};

export default function LogCravingDialog({ children, defaults = {}, onDone }) {
  const { addCraving } = useApp();
  const [open, setOpen] = useState(false);
  const [intensity, setIntensity] = useState(defaults.intensity ?? 6);
  const [trigger, setTrigger] = useState(defaults.trigger ?? "Stress");
  const [emotion, setEmotion] = useState("Neutre");
  const [strategy, setStrategy] = useState(defaults.strategy ?? "");
  const [outcome, setOutcome] = useState(defaults.outcome ?? "resisted");
  const [note, setNote] = useState("");
  const resisted = outcome === "resisted";

  const submit = () => {
    addCraving({ intensity, trigger, emotion, strategy: resisted ? strategy : "", outcome, note });
    const [title, description] = FEEDBACK[outcome];
    toast.success(title, { description });
    setOpen(false);
    setNote("");
    if (onDone) onDone();
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="max-h-[90vh] overflow-y-auto rounded-3xl border-[#E9E1D6] bg-[#FFFDF9] sm:max-w-lg" data-testid="log-craving-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Noter une envie</DialogTitle>
          <DialogDescription>Observer tes envies t'aide à comprendre tes déclencheurs.</DialogDescription>
        </DialogHeader>
        <div className="space-y-6 pt-2">
          <IntensityField value={intensity} onChange={setIntensity} />
          <div className="grid grid-cols-2 gap-3">
            <SelectField label="Déclencheur" value={trigger} onChange={setTrigger} options={TRIGGERS} testid="trigger-select" />
            <SelectField label="Émotion" value={emotion} onChange={setEmotion} options={EMOTIONS} testid="emotion-select" />
          </div>
          <OutcomeField value={outcome} onChange={setOutcome} />
          {resisted && <SelectField label="Ce qui m'a aidé" value={strategy} onChange={setStrategy} options={STRATEGIES} testid="strategy-select" placeholder="Choisir une stratégie" />}
          <div>
            <span className="mb-2 block text-sm font-semibold">Note (facultatif)</span>
            <Textarea value={note} onChange={(e) => setNote(e.target.value)} placeholder="Que s'est-il passé ?" className="rounded-xl bg-white" data-testid="craving-note" />
          </div>
          <Button onClick={submit} className="h-12 w-full rounded-full bg-[#2F4A3A] text-base hover:bg-[#243A2D]" data-testid="submit-craving-btn">Enregistrer</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
